// extracted by mini-css-extract-plugin
module.exports = {"container":"EventCalendarArticle_container__3vSqg","description":"EventCalendarArticle_description__1dbpW"};